(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityFullEditController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'govNotificationDelay', 'biaResponsibilityService'];

    function Controller($scope, $timeout, $state, govNotificationDelay, biaResponsibilityService) {

        $scope.ctrlCtxt = {};

        // Is Save Changes Disabled?
        $scope.isSaveChangesDisabled = function (form) {
            if (_.isUndefined(form)) return;
            return form.$invalid;
        };

        // Reset 
        $scope.reset = function () {
            $state.reload();
        };

        // Close Modal
        $scope.closeModal = function () {
            $scope.boxContext.OnModalClose();
        };

        // Save Changes
        $scope.saveChanges = function () {
            $scope.updateBIAResponsibility();
        };

        // Update BCM Responsibility
        $scope.updateBIAResponsibility = function () {

            if ($scope.isSaveChangesDisabled($scope.form)) {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                    $scope.ctrlCtxt.showSubmitError = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isFormInvalidMsgShow = false;

            return biaResponsibilityService
                        .updateBIAResponsibility($scope.boxModel.BIAProfileID, $scope.boxModel.BIAResponsibilityID, $scope.boxModel)
                        .then(function (updatedBiaResponsibility) {
                            $scope.boxModel = updatedBiaResponsibility;
                            $state.go('^', {}, { reload: true });
                        });
        };

    }

})();